import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultInterceptorChainClass;
function DefaultInterceptorChain() {
  if (DefaultInterceptorChainClass === VOID) {
    class $ {
      constructor(interceptors, index) {
        this.n62_1 = interceptors;
        this.o62_1 = index;
      }
      p62(request) {
        // Inline function 'kotlin.check' call
        if (!(this.o62_1 < this.n62_1.q2())) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.n62_1.r2(this.o62_1).q62(request, new (DefaultInterceptorChain())(this.n62_1, this.o62_1 + 1 | 0));
      }
    }
    initMetadataForClass($, 'DefaultInterceptorChain');
    DefaultInterceptorChainClass = $;
  }
  return DefaultInterceptorChainClass;
}
//region block: exports
export {
  DefaultInterceptorChain as DefaultInterceptorChain10weji0clzo5q,
};
//endregion

//# sourceMappingURL=ApolloInterceptor.mjs.map
